// extracted by mini-css-extract-plugin
export default {"root":"App_root__D2B5k","container":"App_container__pnDtJ","content":"App_content__Zr892"};